import GlobalStoreService from "../services/global-store.service";

const addItem = (component) => {
    const chatHistoryForCurrentScenario = GlobalStoreService.get("chatHistoryForCurrentScenario");
    chatHistoryForCurrentScenario.push(component);
    updateChatHistory(chatHistoryForCurrentScenario);
};

const addGoToPreviousOption = (result, oldScenario) => {
    if (result &&
        result.scenarioActive &&
        result && result.scenario &&
        result.scenario.scenarioStep &&
        result.scenario.scenarioStep.options &&
        result.scenario.scenarioId &&
        result.notes !== "" &&
        oldScenario &&
        oldScenario.scenario &&
        oldScenario.scenario.scenarioId === result.scenario.scenarioId &&
        !result.scenarioSwitchExecuted
    ) {
        if (result.scenario.scenarioIntent &&
            (result.scenario.scenarioIntent).toLowerCase() === "I want to activate International Roaming".toLowerCase()) {
            return (result
                && result.scenario
                && result.scenario.scenarioStep
                && result.scenario.scenarioStep.options) ?
                result.scenario.scenarioStep.options :
                [];
        }
        let result_after_add = result;

        const option = {
            choiceId: "1",
            choiceText: "Previous Step",
            displayText: "Previous Step",
            nextStep: "2"
        };

        result_after_add.scenario.scenarioStep.options.push(option);

        return result_after_add.scenario.scenarioStep.options;
    }
    return (result
        && result.scenario
        && result.scenario.scenarioStep
        && result.scenario.scenarioStep.options) ?
        result.scenario.scenarioStep.options :
        [];
};

const updateChatHistory = (updatedValue) => {
    GlobalStoreService.set("chatHistoryForCurrentScenario", updatedValue);
};

const resetChatHistory = () => {
    GlobalStoreService.set("chatHistoryForCurrentScenario", []);
};

const goToPrevious = (message_comp) => {
    const chatHistoryForCurrentScenario = GlobalStoreService.get("chatHistoryForCurrentScenario");
    if (chatHistoryForCurrentScenario.length > 0) {

        chatHistoryForCurrentScenario.pop();

        const chatHistoryItem = chatHistoryForCurrentScenario[chatHistoryForCurrentScenario.length - 1];
        message_comp.addNewMessages({ new_messages: chatHistoryItem.message_objects })
        // message_comp.addComponent([chatHistoryItem.component]);
        updateChatHistory(chatHistoryForCurrentScenario);

        message_comp.setState({
            current_scenario: chatHistoryItem.scenarioResponse,
            showFeedbackOptions: false,
            response_options: chatHistoryItem.chatItem
        });
    }
    return null;
};


export default {
    addItem,
    updateChatHistory,
    resetChatHistory,
    goToPrevious,
    addGoToPreviousOption
};






// WEBPACK FOOTER //
// ./src/services/chatHistory.service.js